import type { MaturityStage } from '@reflex/ui/components/shared/MaturityBadge';

/**
 * The maturity stage of the Reflex product itself, rendered as the chip beside
 * the wordmark on every brand surface (the auth lockup and the sidebar header).
 * Those surfaces must never disagree, so they read the stage from here rather
 * than each hardcoding it.
 *
 * Feature-level stages are not this: pass `stage` to `MaturityBadge` directly
 * where the feature lives.
 */
export const PRODUCT_MATURITY_STAGE = 'beta' satisfies MaturityStage;
